/**
 * Глубокая копия через JSON.
 *
 * Достаточно для plain-data структур комбо/модификаторов (без функций, Date, Map и т.п.).
 * При ошибке сериализации возвращает исходное значение.
 */
export const cloneDeep = <T>(value: T): T => {
	if (value === null || value === undefined) return value;
	try {
		return JSON.parse(JSON.stringify(value));
	} catch {
		return value;
	}
};
